import React from 'react';

/**
 * SectionHeader — the quiet label above a content section (Paper "Components / Hosted",
 * SectionHeader; SPEC §C). About, Location, Frequently asked questions on hosted pages,
 * the overlay and the elements details page.
 *
 * Label 14/20 medium in the secondary text role, 8px gap, then a 1px subtle hairline.
 * The gap to the content below (12px) and between sections (32px) belongs to the caller.
 *
 * @param {'h2'|'h3'} [as='h2'] - Heading tag. The label is a real heading so the page
 *   outline keeps its sections; the styling is the same at every level.
 */
function SectionHeader({ as: HeadingTag = 'h2', id, children }) {
  return (
    <div className="flex flex-col gap-[var(--cs-space-2)]">
      <HeadingTag
        id={id}
        className="m-0 text-[length:var(--cs-text-sm)] leading-[var(--cs-leading-20)] font-medium text-[color:var(--cs-text-secondary)]"
      >
        {children}
      </HeadingTag>
      <div aria-hidden="true" className="h-px shrink-0 bg-[color:var(--cs-border-control-subtle)]" />
    </div>
  );
}

export default SectionHeader;
